const DEFAULT_DASHBOARD_URL = 'https://nhozrszypc.execute-api.us-east-1.amazonaws.com/default';
const DEFAULT_CHATBOT_URL = 'https://hmliiq40k5.execute-api.us-east-1.amazonaws.com/prod';
const DEFAULT_WEBSOCKET_URL = 'wss://pni9azwg7e.execute-api.us-east-1.amazonaws.com/prod';

function normalizeOrigin(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getDashboardUrl(): string {
  return normalizeOrigin(DEFAULT_DASHBOARD_URL);
}

export function getChatbotUrl(): string {
  return normalizeOrigin(DEFAULT_CHATBOT_URL);
}

export function getWebSocketUrl(): string {
  return normalizeOrigin(DEFAULT_WEBSOCKET_URL);
}

export function toWebSocketUrl(url: string): string {
  if (url.startsWith('ws://') || url.startsWith('wss://')) return url;
  if (url.startsWith('http://')) return `ws://${url.slice('http://'.length)}`;
  if (url.startsWith('https://')) return `wss://${url.slice('https://'.length)}`;
  return url;
}
